import { BPCDisplayConfigField } from '@core/interfaces/bpc-display-config';
import PaginationInterface from '@core/interfaces/pagination-interface';
import Vue from 'vue';
import { Component, Prop, PropSync, Watch } from 'vue-property-decorator';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faSearch, faTimes, faAngleLeft, faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

library.add(faSearch, faTimes, faAngleLeft, faAngleRight);

@Component({
  name: 'bpc-table-header',
  components: {
    'font-awesome-icon': FontAwesomeIcon,
  },
})
export default class TableHeader extends Vue {
  @Prop(Array) readonly fields: BPCDisplayConfigField[];
  @Prop({ type: Array, default: () => [5, 10, 15, 20, 50, 100, 200] })
  readonly pageOptions: number[];

  @Prop({ type: Boolean, default: true }) readonly withSearch: boolean;
  @Prop({ type: Boolean, default: true }) readonly showOrderBy: boolean;
  @Prop({ type: Boolean, default: true }) readonly showPagination: boolean;
  @PropSync('pagination', { type: Object }) syncedPagination!: PaginationInterface;
  @PropSync('search', { type: String }) syncedSearch!: string;
  @PropSync('orderDirection', { type: String }) syncedOrderDirection!: string;
  @PropSync('orderBy', { type: String }) syncedOrderBy!: string;

  get orderByOptions() {
    // Create an options list from our fields
    return this.fields
      .filter((f: BPCDisplayConfigField) => f.sortable)
      .map((f: BPCDisplayConfigField) => ({
        text: f.label,
        value: f.key,
      }));
  }

  mounted() {
    // this.initialicePagination();
  }

  // initialicePagination() {
  //   this.perPage = this.pagination.per_page;
  //   this.currentPage = this.pagination.current_page;
  // }

  nextPage() {
    this.syncedPagination.current_page = Math.min(
      this.syncedPagination.current_page + 1,
      this.syncedPagination.last_page,
    );
  }
  prevPage() {
    this.syncedPagination.current_page = Math.max(this.syncedPagination.current_page - 1, 1);
  }

  clickOnChangeOrderDirection(direction) {
    this.syncedOrderDirection = direction;
  }

  @Watch('syncedSearch')
  onSyncedSearchChange(val: string) {
    console.log('onSyncedSearchChange', val, this.syncedSearch);
  }
}
